const CommunicationTemplatesStyles = {
  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fieldBoxContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: "1rem",
  },
  attachmentBoxContainer: {
    display: "flex",
    gap: 1,
    alignItems: "center",
    marginTop: "0.2rem",
  },
  formLabel: {
    color: "rgba(0, 0, 0, 0.8)",
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
  },
  toolTipPopper: {
    zIndex: 9999,
  },
  actionButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  templateCardContainer: {
    padding: "0.75rem",
    height: "100%",
    minHeight: "120px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardContent: {
    padding: 0,
  },
  templateCardTitle: {
    fontSize: "0.9rem",
    marginBottom: "0.5rem",
  },
  cardActionButtons: {
    dispay: "flex",
    justifyContent: "flex-start",
    mt: "auto",
  },
  cardActionsFooter: {
    dispay: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: 0,
    gap: "0.35rem",
    "& > :not(style) ~ :not(style)": {
      marginLeft: 0,
    },
  },
  dateAndVersionContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  updatedAtText: {
    fontSize: "0.8rem",
    fontStyle: "italic",
    color: "#64748B",
  },
  versionChipStyles: {
    backgroundColor: "transparent",
    border: "1px solid #E2E8F0",
    fontSize: "0.8rem",
  },
  versionsDataContainer: {
    width: "40%",
    height: "70vh",
    overflowY: "scroll",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    boxShadow:
      "0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    minHeight: "500px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" },
  },
  versionDataSectionHeading: {
    padding: "1rem",
    fontSize: "0.9rem",
    fontWeight: "600",
  },
  versionsData: {
    width: "100%",
    display: "flex",
    padding: "0.75rem",
    gap: "0.5rem",
    flexDirection: "column",
  },
  versionDetailsContainer: {
    width: "60%",
    height: "70vh",
    overflowY: "scroll",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    boxShadow:
      "0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    minHeight: "500px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" },
  },
  templateVersionCard: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    padding: "1rem",
    gap: "0.5rem",
    boxShadow:
      "0 1px 2px 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#f5f5f5 ",
    },
  },
};
export default CommunicationTemplatesStyles;
